import React from 'react';
import PropTypes from 'prop-types';

import './MyAccountSubMenu.css';

const MyAccountSubMenu = ({ baseUrl, active }) => (
  <section className="my-account-sub-menu">
    <div className="my-account-sub-menu__container">
      <ul>
        <a href={`${baseUrl}my-account/#`}>
          <span className={active === 'my-account' ? 'active' : ''}>My account</span>
        </a>
        <a href={`${baseUrl}my-account/#!orders`}>
          <span className={active === 'my-subscription' ? 'active' : ''}>My subscription &amp; orders</span>
        </a>
        <a href={`${baseUrl}my-account/#!survey`}>
          <span className={active === 'my-personal-profile' ? 'active' : ''}>Personal profile</span>
        </a>
        <a href={`${baseUrl}my-account/referral-dashboard/`}>
          <span className={active === 'my-referrals' ? 'active' : ''}>My referrals</span>
        </a>
      </ul>
    </div>
  </section>
);

MyAccountSubMenu.defaultProps = {
  baseUrl: process.env.REACT_APP_SITE_URL,
  active: 'my-referrals',
};

MyAccountSubMenu.propTypes = {
  baseUrl: PropTypes.string,
  active: PropTypes.string,
};

export default MyAccountSubMenu;
